import React from 'react'
import clsx from 'clsx'
import get from 'lodash/get'

import styles from './styles.module.scss'

type BadgeTypes = 'primary' | 'success' | 'danger' | 'warning'

interface BadgesProps {
  variant?: BadgeTypes
  children?: React.ReactNode | React.ReactNode[]
}

const Badge: React.FC<BadgesProps> = ({ children, variant = 'danger' }) => {
  let badgeText = children

  if (typeof children === 'number') {
    badgeText = `0${children}`.substr(
      children.toString().length + 1 === 2 ? 0 : 1,
      children.toString().length + 1,
    )
  }

  return (
    <div
      className={clsx(
        styles.badge,
        get(styles, variant),
        !parseInt(String(children)) && styles.hidden,
      )}
    >
      {badgeText}
    </div>
  )
}

export default React.memo(Badge)
